export const EXTRA_CITIES = {
  ontario: [
    { name: "Oakville", slug: "oakville", pop: "213,759" },
    { name: "Richmond Hill", slug: "richmond-hill", pop: "202,022" },
    { name: "Burlington", slug: "burlington", pop: "186,948" },
    { name: "Whitby", slug: "whitby", pop: "138,501" },
    { name: "Milton", slug: "milton", pop: "132,979" },
    { name: "Ajax", slug: "ajax", pop: "126,666" },
    { name: "Waterloo", slug: "waterloo", pop: "121,436" },
    { name: "Brantford", slug: "brantford", pop: "104,688" },
    { name: "Pickering", slug: "pickering", pop: "99,186" },
    { name: "Newmarket", slug: "newmarket", pop: "87,942" },
    { name: "Belleville", slug: "belleville", pop: "55,071" },
    { name: "Cornwall", slug: "cornwall", pop: "47,845" },
    { name: "Chatham-Kent", slug: "chatham-kent", pop: "44,506" },
    { name: "Timmins", slug: "timmins", pop: "41,145" },
    { name: "Orillia", slug: "orillia", pop: "33,411" },
    { name: "Stratford", slug: "stratford", pop: "33,232" },
    { name: "Brockville", slug: "brockville", pop: "22,116" },
    { name: "Owen Sound", slug: "owen-sound", pop: "21,612" },
  ],
  "british-columbia": [
    { name: "Saanich", slug: "saanich", pop: "117,735" },
    { name: "Delta", slug: "delta", pop: "108,455" },
    { name: "Maple Ridge", slug: "maple-ridge", pop: "90,990" },
    { name: "New Westminster", slug: "new-westminster", pop: "78,916" },
    { name: "Port Coquitlam", slug: "port-coquitlam", pop: "61,498" },
    { name: "North Vancouver", slug: "north-vancouver", pop: "58,120" },
    { name: "Vernon", slug: "vernon", pop: "44,519" },
    { name: "West Vancouver", slug: "west-vancouver", pop: "44,122" },
    { name: "Penticton", slug: "penticton", pop: "36,885" },
    { name: "Campbell River", slug: "campbell-river", pop: "35,519" },
    { name: "Courtenay", slug: "courtenay", pop: "28,420" },
    { name: "Cranbrook", slug: "cranbrook", pop: "20,499" },
  ],
  alberta: [
    { name: "St. Albert", slug: "st-albert", pop: "68,232" },
    { name: "Spruce Grove", slug: "spruce-grove", pop: "37,645" },
    { name: "Leduc", slug: "leduc", pop: "34,094" },
    { name: "Lloydminster", slug: "lloydminster", pop: "31,582" },
    { name: "Fort Saskatchewan", slug: "fort-saskatchewan", pop: "27,088" },
    { name: "Chestermere", slug: "chestermere", pop: "22,163" },
    { name: "Camrose", slug: "camrose", pop: "18,772" },
    { name: "Brooks", slug: "brooks", pop: "14,924" },
  ],
  quebec: [
    { name: "Saint-Jean-sur-Richelieu", slug: "saint-jean-sur-richelieu", pop: "98,036" },
    { name: "Repentigny", slug: "repentigny", pop: "86,100" },
    { name: "Brossard", slug: "brossard", pop: "85,721" },
    { name: "Saint-Jérôme", slug: "saint-jerome", pop: "80,213" },
    { name: "Drummondville", slug: "drummondville", pop: "79,258" },
    { name: "Granby", slug: "granby", pop: "69,025" },
    { name: "Saint-Hyacinthe", slug: "saint-hyacinthe", pop: "57,239" },
    { name: "Shawinigan", slug: "shawinigan", pop: "49,620" },
    { name: "Rimouski", slug: "rimouski", pop: "48,664" },
    { name: "Victoriaville", slug: "victoriaville", pop: "47,760" },
  ],
  "nova-scotia": [
    { name: "Glace Bay", slug: "glace-bay", pop: "16,915" },
    { name: "Truro Area — Bible Hill", slug: "bible-hill", pop: "8,900" },
    { name: "New Glasgow", slug: "new-glasgow", pop: "9,075" },
    { name: "Amherst", slug: "amherst", pop: "9,404" },
    { name: "Bridgewater", slug: "bridgewater", pop: "8,790" },
    { name: "Yarmouth", slug: "yarmouth", pop: "6,761" },
  ],
  manitoba: [
    { name: "Winkler", slug: "winkler", pop: "13,745" },
    { name: "Portage la Prairie", slug: "portage-la-prairie", pop: "13,304" },
    { name: "Thompson", slug: "thompson", pop: "13,035" },
    { name: "Selkirk", slug: "selkirk", pop: "10,504" },
  ],
  saskatchewan: [
    { name: "Swift Current", slug: "swift-current", pop: "16,750" },
    { name: "Yorkton", slug: "yorkton", pop: "16,280" },
    { name: "North Battleford", slug: "north-battleford", pop: "13,836" },
    { name: "Estevan", slug: "estevan", pop: "10,851" },
  ],
  "new-brunswick": [
    { name: "Quispamsis", slug: "quispamsis", pop: "18,768" },
    { name: "Miramichi", slug: "miramichi", pop: "17,692" },
    { name: "Edmundston", slug: "edmundston", pop: "16,437" },
    { name: "Bathurst", slug: "bathurst", pop: "11,897" },
  ],
  "newfoundland-and-labrador": [
    { name: "Conception Bay South", slug: "conception-bay-south", pop: "26,199" },
    { name: "Paradise", slug: "paradise", pop: "21,389" },
    { name: "Grand Falls-Windsor", slug: "grand-falls-windsor", pop: "13,853" },
  ],
  "prince-edward-island": [
    { name: "Stratford", slug: "stratford", pop: "10,927" },
    { name: "Cornwall", slug: "cornwall", pop: "5,348" },
    { name: "Montague", slug: "montague", pop: "1,961" },
  ],
  yukon: [{ name: "Dawson City", slug: "dawson-city", pop: "1,577" }],
  "northwest-territories": [{ name: "Hay River", slug: "hay-river", pop: "3,528" }],
  nunavut: [{ name: "Rankin Inlet", slug: "rankin-inlet", pop: "2,975" }],
};
